import Vue, { VNode } from 'vue';
import App from './UI/App.vue';
import { router } from './router/router';

import '@/router/Routes/helpers/componentHooks';

import store from './store';
import '@/UI/assets/scss/main.scss';
import 'ant-design-vue/dist/antd.css';
import '@/UI/assets/scss/pult-system.scss';
import { prepareRepository } from '@/plugins';
//import vuetify from './plugins/vuetify';
import i18n from './locales';
import utc from 'dayjs/plugin/utc';
import dayjs from "dayjs";


dayjs.extend(utc);


Vue.config.productionTip = false;

/*****/
Vue.config.devtools = true;
Vue.config.errorHandler = function (err: any, vm, info) {

    console.log('App error : ');
    console.error(err);
    console.log('App error info : ');
    console.log(info);

    console.log('App error VM : ');
    console.log(vm);
    // handle error
    // `info` is a Vue-specific error info, e.g. which lifecycle hook
    // the error was found in. Only available in 2.2.0+
};
Vue.config.warnHandler = (msg: string, vm, trace) => {
    // `trace` is the component hierarchy trace
    /*console.log('App warning : ');
    console.warn(msg);
    console.log('App warning trace : ' + trace);
    console.log(vm);
    console.log(trace);*/
};
/****/

prepareRepository(store);
export const eventBus = new Vue();

//Vue.prototype.$eventHub = new Vue();

new Vue({
    render: (h): VNode => h(App),
    router,
    i18n,
    store,
    //vuetify,
}).$mount('#app');
